import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = {
  id: "team",
  class: "container lg:w-[50%] mx-auto py-24 sm:py-32"
}
const _hoisted_2 = { class: "flex flex-wrap gap-6 justify-center" }
const _hoisted_3 = { class: "aspect-square overflow-hidden bg-muted/30 flex items-center justify-center" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "text-[#ff9500]" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["href", "aria-label"]

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardFooter,
} from "@/components/landingPage/ui/card";

import LinkedInIcon from "@/icons/LinkedInIcon.vue";
import GithubIcon from "@/icons/GithubIcon.vue";
import XIcon from "@/icons/XIcon.vue";

// Team images (from src/assets/team)
import aurelieImg from "@/assets/team/aurelie-sigrand.jpg";
import margauxImg from "@/assets/team/margaux-dacquet.jpg";
import marieImg from "@/assets/team/marie-lourdais.jpg";
import vladImg from "@/assets/team/vlad-zaharia.jpg";
import charlesImg from "@/assets/team/charles-fassel.jpg";
import eliyanImg from "@/assets/team/eliyan-dochev.jpg";
import thomasImg from "@/assets/team/thomas-fiancette.jpg";
import vasilyImg from "@/assets/team/vasily-novikov.jpg";
import gabrielImg from "@/assets/team/gabriel-lepinay.jpg";
import anonymeImg from "@/assets/team/anonyme.jpg";

interface TeamProps {
  imageUrl: string;
  firstName: string;
  lastName: string;
  positions: string[];
  socialNetworks: SocialNetworkProps[];
}

interface SocialNetworkProps {
  name: string;
  url: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Team',
  setup(__props) {

const teamList: TeamProps[] = [
  {
    imageUrl: vladImg,
    firstName: "Vlad",
    lastName: "Zaharia",
    positions: ["Project Manager Front-end Developer"],
    socialNetworks: [],
  },
  {
    imageUrl: thomasImg,
    firstName: "Thomas",
    lastName: "Fiancette",
    positions: ["Front-end Developer API & data integration"],
    socialNetworks: [],
  },
  {
    imageUrl: charlesImg,
    firstName: "Charles",
    lastName: "Fassel",
    positions: ["Front-end Developer Game design & integration"],
    socialNetworks: [],
  },
  {
    imageUrl: eliyanImg,
    firstName: "Eliyan",
    lastName: "Dochev",
    positions: ["Back-End Developer API & database"],
    socialNetworks: [],
  },
  {
    imageUrl: anonymeImg,
    firstName: "Vasily",
    lastName: "Novikov",
    positions: ["DevOps"],
    socialNetworks: [],
  },
  {
    imageUrl: gabrielImg,
    firstName: "Gabriel",
    lastName: "Lepinay",
    positions: ["Cybersecurity"],
    socialNetworks: [],
  },
  {
    imageUrl: aurelieImg,
    firstName: "Aurélie",
    lastName: "Sigrand",
    positions: ["Fondatrice association Ikigai"],
    socialNetworks: [],
  },
  {
    imageUrl: margauxImg,
    firstName: "Margaux",
    lastName: "Dacquet",
    positions: ["Spécialiste dans l'orientation des jeunes"],
    socialNetworks: [],
  },
  {
    imageUrl: marieImg,
    firstName: "Marie",
    lastName: "Lourdais",
    positions: ["Psychologue TSA"],
    socialNetworks: [],
  },
];

const socialIcon = (socialName: string) => {
  switch (socialName) {
    case "LinkedIn":
      return LinkedInIcon;

    case "Github":
      return GithubIcon;

    case "X":
      return XIcon;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-center mb-8" }, [
      _createElementVNode("h2", { class: "text-lg text-[#ff9500] text-center mb-2 tracking-wider" }, "Équipe"),
      _createElementVNode("h2", { class: "text-3xl md:text-4xl text-center font-bold" }, " Une équipe pluridisciplinaire engagée ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(teamList, ({
          imageUrl,
          firstName,
          lastName,
          positions,
          socialNetworks,
        }) => {
        return _createVNode(_unref(Card), {
          key: imageUrl,
          class: "bg-muted/60 dark:bg-card flex flex-col overflow-hidden group/hoverimg w-full max-w-[200px] h-[380px]"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(CardHeader), { class: "p-0 gap-0" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("img", {
                    src: imageUrl,
                    alt: `${firstName} ${lastName}`,
                    class: "w-full h-full object-contain saturate-0 transition-all duration-200 ease-linear group-hover/hoverimg:saturate-100 group-hover/hoverimg:scale-[1.01]"
                  }, null, 8, _hoisted_4)
                ]),
                _createVNode(_unref(CardTitle), { class: "py-6 pb-4 px-6" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(firstName) + " ", 1),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(lastName), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(positions, (position, index) => {
              return (_openBlock(), _createBlock(_unref(CardContent), {
                key: index,
                class: _normalizeClass({
            'pb-0 text-muted-foreground ': true,
            'pb-4': index === positions.length - 1,
          })
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(position), 1),
                  (index < positions.length - 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, ","))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["class"]))
            }), 128)),
            _createVNode(_unref(CardFooter), { class: "space-x-4 mt-auto" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(socialNetworks, ({ name, url }) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: name,
                    href: url,
                    target: "_blank",
                    class: "hover:opacity-80 transition-all",
                    "aria-label": `Visit our ${name} page`
                  }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(socialIcon(name))))
                  ], 8, _hoisted_7))
                }), 128))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      }), 64))
    ])
  ]))
}
}

})